import React, { useEffect } from "react";
import {
  IonButtons,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import findUsers from "../../store/users/actions/findUsers";
import { KpisSection } from "./components/KpisSection";
import { selectMessages } from "../../store/users/selectors/selectMessages";
import { findMessages } from "../../store/users/actions/findMessages";
import { chatbubbleOutline, documentOutline, documentTextOutline } from "ionicons/icons";
import { Message } from "../../@types/message";

export const BusinessHome: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(findUsers());
    dispatch(findMessages());
  }, [dispatch]);

  const messages = useSelector(selectMessages);
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>Gerencia</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Gerencia</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section className="ion-padding">
          <KpisSection />

          <h2 className="ion-margin-start">
            <IonText color="primary">Actividad</IonText>
          </h2>
        </section>

        <section className="ion-padding-horizontal">
          {Object.entries(messages).length === 0 && (
            <IonItem lines="none">
              <IonLabel>
                <IonText color="medium">No se ha encontrado actividad</IonText>
              </IonLabel>
            </IonItem>
          )}
          {Object.entries(messages).map(([key, value]: any) => (
            <article key={key}>
              <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

              {value.map((messageItem: Message) => (
                <IonItem
                  routerLink={
                    messageItem.module === "document"
                      ? `/app/rrhh/acuerdos/${messageItem.document?.id}`
                      : messageItem.module === "user"
                      ? `/app/rrhh/usuarios/${messageItem.room}`
                      : undefined
                  }
                  detail
                  lines="none"
                  className="ion-margin-bottom"
                  key={messageItem.id}
                  button
                >
                  {isPlatform("desktop") && (
                    <IonIcon icon={documentTextOutline} slot="start"></IonIcon>
                  )}
                  <IonLabel class="ion-text-wrap">
                    <h2>
                      <IonText style={{ fontWeight: 500, paddingRight: 5 }}>
                        {messageItem.createdBy?.name}
                      </IonText>
                      <IonText>{messageItem.text}</IonText>
                    </h2>
                    {messageItem.comment && (
                      <h3 style={{ marginTop: 6, marginBottom: 4 }}>
                        <IonIcon icon={chatbubbleOutline}></IonIcon>
                        <span className="ion-padding-start">{messageItem.comment}</span>
                      </h3>
                    )}
                  </IonLabel>
                  {isPlatform("desktop") && messageItem.document && (
                    <IonChip outline color="tertiary" slot="end" class="ion-margin-end">
                      <IonLabel>
                        <IonIcon icon={documentOutline} class="ion-margin-end"></IonIcon>
                        <IonText>
                          <small>{messageItem.document.title}</small>
                        </IonText>
                      </IonLabel>
                    </IonChip>
                  )}
                  <IonText slot="end" class="ion-margin-end">
                    <h5>{messageItem.createdAtLegible?.time}</h5>
                  </IonText>
                </IonItem>
              ))}
            </article>
          ))}
        </section>
      </IonContent>
    </IonPage>
  );
};
